import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { handleGlobalModal } from '../../ducks/Global/actions';
import { disclaimer, privacyPolicy } from '../../data/legal';

/* Slim, legal-only footer for the focused /nutrition tool flow. Keeps
   Privacy/Disclaimer reachable (and a copyright line) without the full
   marketing footer's exit links, which would leak people out of the funnel. */

export function LegalFooter({ tone = 'dark' }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const year = new Date().getFullYear();
  const light = tone === 'light';

  const linkClass = light
    ? 'bg-transparent text-black/45 transition-colors hover:text-black/80'
    : 'bg-transparent text-white/45 transition-colors hover:text-white/80';
  const dot = light ? 'text-black/15' : 'text-white/15';

  return (
    <footer
      className={
        light
          ? 'relative border-t border-black/[0.06] bg-[#f4f6fa] px-5 py-6'
          : 'relative border-t border-white/5 bg-[#080B14] px-5 py-6'
      }
    >
      <div
        className={`mx-auto flex max-w-xl flex-wrap items-center justify-center gap-x-3 gap-y-1 text-xs ${
          light ? 'text-black/45' : 'text-white/45'
        }`}
      >
        <button
          type='button'
          className={linkClass}
          onClick={() => dispatch(handleGlobalModal(true, privacyPolicy))}
        >
          {t('legalFooter.privacy')}
        </button>
        <span className={dot} aria-hidden>
          ·
        </span>
        <button
          type='button'
          className={linkClass}
          onClick={() => dispatch(handleGlobalModal(true, disclaimer))}
        >
          {t('legalFooter.disclaimer')}
        </button>
        <span className={dot} aria-hidden>
          ·
        </span>
        <span>© {year} Alvaro Fitness</span>
      </div>
    </footer>
  );
}
